import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

const logout =()=>{
  localStorage.clear();
  localStorage.setItem("logout", Date.now().toString());
  localStorage.setItem("role", "employer");
  }


class EmployerService {


    static getemployerProfile() {
        let api = API_PATHS.getemployerProfile;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
            .get(api, { headers: {"x-access-token" : token}})
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
    }

    static getEmployerWallet() {
        const user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
            .get(API_PATHS.employerWallet, { headers: { "x-access-token": token } })
            .then((response) => response.data)
            .catch((Error) => {
                if (Error?.response?.status === 401) {
                    logout();
                }
                throw Error;
            });
    }

    static getEmployerReferral() {
        const user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
            .get(API_PATHS.employerReferral, { headers: { "x-access-token": token } })
            .then((response) => response.data)
            .catch((Error) => {
                if (Error?.response?.status === 401) {
                    logout();
                }
                throw Error;
            });
    }

    static getSharedProfiles(item) {
      let api = '';
      api = API_PATHS.getSharedprofile   +`?limit=${item.limit}&page=${item.page}`;
      let user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.token;
      return axios
          .get(api, { headers: {"x-access-token" : token}})
          .then((response) => {
              if (response.data) {
                  // localStorage.setItem("user", JSON.stringify(response.data));
              }
              return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
    }
    
    static getSharedProfileDetails(id) {
    
        let api = "";
        api = API_PATHS.getsharedprofileDetails +"?cookId="+id;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api,  { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

    static getemployerDashbaordData() {
      let api = '';
      api = API_PATHS.getDashboardData;
      let user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.token;
      const config = {
        headers: {
          "x-access-token": token,
        },
      };
      return axios
          .get(api,config)
          .then((response) => {
              if (response.data) {
                  // localStorage.setItem("user", JSON.stringify(response.data));
              }
              return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
  }

    static getemployerDashboardDataV2() {
      const api = API_PATHS.getDashboardDataV2;
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.token;
      return axios
        .get(api, { headers: { "x-access-token": token } })
        .then((response) => response.data)
        .catch((Error) => {
          if (Error?.response?.status === 401) {
            logout();
          }
          throw Error;
        });
    }

    static getemployerDashboardDataV3() {
      const api = API_PATHS.getDashboardDataV3;
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.token;
      return axios
        .get(api, { headers: { "x-access-token": token } })
        .then((response) => response.data)
        .catch((Error) => {
          if (Error?.response?.status === 401) {
            logout();
          }
          throw Error;
        });
    }
    static getplanHistory() {
      let api = '';
      api = API_PATHS.employerplanHistory;
      let user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.token;
      return axios
          .get(api, { headers: {"x-access-token" : token}})
          .then((response) => {
              if (response.data) {
                  // localStorage.setItem("user", JSON.stringify(response.data));
              }
              return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
  }

  static getAllApplications(item) {
    let api = '';
    api = API_PATHS.getapplicationsReceived +`?limit=${item.limit}&page=${item.page}`;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
        .get(api, { headers: {"x-access-token" : token}})
        .then((response) => {
            if (response.data) {
                // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static getAllApplicationsdataV2(item = {}) {
  const params = new URLSearchParams();
  if (item.limit) params.set("limit", item.limit);
  if (item.page) params.set("page", item.page);
  if (item.applicationStatus) params.set("applicationStatus", item.applicationStatus);
  if (item.jobId) params.set("jobId", item.jobId);
  if (item.cookId) params.set("cookId", item.cookId);

  const query = params.toString();
  const api = query
    ? `${API_PATHS.getapplicationsReceivedV2}?${query}`
    : API_PATHS.getapplicationsReceivedV2;

  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static getJobAiMatchSummary(jobId) {
  const api = `${API_PATHS.jobAiMatchesSummary}?jobId=${encodeURIComponent(jobId)}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api, { headers: { "x-access-token": token } })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static getJobAiMatches(item = {}) {
  const params = new URLSearchParams();
  if (item.jobId) params.set("jobId", item.jobId);
  if (item.limit) params.set("limit", item.limit);
  if (item.page) params.set("page", item.page);
  const api = `${API_PATHS.jobAiMatchesFetch}?${params.toString()}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api, { headers: { "x-access-token": token } })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static generateMoreJobAiMatches(jobId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(
      API_PATHS.jobAiMatchesGenerateMore,
      { jobId },
      { headers: { "x-access-token": token } }
    )
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static dislikeJobAiMatch(item = {}) {
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(API_PATHS.jobAiMatchesDislike, item, {
      headers: { "x-access-token": token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static getAllApplicationsdata() {
  let api = '';
  api = API_PATHS.getapplicationsReceived;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => {
          if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static getJobApplicationsV2(item = {}) {
  const params = new URLSearchParams();
  if (item.limit) params.set("limit", item.limit);
  if (item.page) params.set("page", item.page);
  if (item.jobId) params.set("jobId", item.jobId);
  if (item.applicationStatus) params.set("applicationStatus", item.applicationStatus);
  if (item.cookId) params.set("cookId", item.cookId);

  const api = `${API_PATHS.getapplicationsReceivedV2}?${params.toString()}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static getJobApplications(item) {
  let api = '';
  api = API_PATHS.getapplicationsReceived +`?limit=${item.limit}&page=${item.page}&jobId=${item.jobId}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => {
          if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}


//get all event requests
static getEventRequests(item) {
  let api = '';
  api = API_PATHS.geteventrequests +`?limit=${item.limit}&page=${item.page}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => {
          if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}


//get house job applications (requirement interests) — v2
static getRequirementRequests(item = {}) {
  const params = new URLSearchParams();
  if (item.limit != null) params.set("limit", item.limit);
  if (item.page != null) params.set("page", item.page);
  if (item.requirementId) params.set("requirementId", item.requirementId);
  if (item.cookId) params.set("cookId", item.cookId);
  if (item.applicationStatus) {
    params.set("applicationStatus", item.applicationStatus);
  }
  if (item.id) params.set("id", item.id);

  const query = params.toString();
  const api = query
    ? `${API_PATHS.houseinterests}?${query}`
    : API_PATHS.houseinterests;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .get(api, { headers: {"x-access-token" : token}})
      .then((response) => {
          if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

    //edit employer service
    static editemployerProfile(item) {
        let api = "";
        api = API_PATHS.editemployerProfile;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .put(api, item, { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
      }

      static UpdateLogin() {
        let api = "";
        api = API_PATHS.updateLastLoginEmployer;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
      
        const config = {
          headers: {
            "x-access-token": token,
          },
        };
        return axios
          .put(api, {},config)
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }


      //post job service for employer
      static PostJobV2(item) {
        const api = API_PATHS.postjobV2;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .post(api, item, { headers: { "x-access-token": token } })
          .then((response) => response.data)
          .catch((Error) => {
            if (Error?.response?.status === 401) {
              logout();
            }
            throw Error;
          });
      }

      static EditJobV2(item) {
        const api = API_PATHS.editjobV2;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .put(api, item, { headers: { "x-access-token": token } })
          .then((response) => response.data)
          .catch((Error) => {
            if (Error?.response?.status === 401) {
              logout();
            }
            throw Error;
          });
      }

      static PostJob(item) {
        let api = "";
        api = API_PATHS.postjob;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .post(api, item, { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

      //editjob service for employer
      static editJob(item) {
        let api = "";
        api = API_PATHS.editjob;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .put(api, item, { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

      //get job service
      static getJob(id) {
        let api = "";
        api = API_PATHS.getjob +"?id="+id;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api,  { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }


      static getChefDetails(id) {
        const api = `${API_PATHS.viewchefDetailsV2}?id=${id}`;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api, { headers: { "x-access-token": token } })
          .then((response) => response.data)
          .catch((Error) => {
            if (Error?.response?.status === 401) {
              logout();
            }
            throw Error;
          });
      }

      static getCookRatingsV2({ id, page = 1, limit = 10 }) {
        const api = `${API_PATHS.cookRatingsV2}?id=${id}&page=${page}&limit=${limit}`;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api, { headers: { "x-access-token": token } })
          .then((response) => response.data)
          .catch((Error) => {
            if (Error?.response?.status === 401) {
              logout();
            }
            throw Error;
          });
      }

      static getApplicationDetailsV2(id) {
        const api = `${API_PATHS.viewApplicationDetailV2}?id=${id}`;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api, { headers: { "x-access-token": token } })
          .then((response) => response.data)
          .catch((Error) => {
            if (Error?.response?.status === 401) {
              logout();
            }
            throw Error;
          });
      }

      static getApplicationDetails(id) {
        let api = "";
        api = API_PATHS.viewApplicationDetail +"?id="+id;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api,  { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

      static getAllJob() {
        let api = "";
        api = API_PATHS.getjob;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        return axios
          .get(api,  { headers: { "x-access-token": token } })
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

//employer mobile number activity log
        static employerMobileactivityLog(item) {
        let api = "";
        api = API_PATHS.employermobieactivity;
        let user = JSON.parse(localStorage.getItem("user"));
        const token = user.data.token;
        const config = {
          headers: {
            "x-access-token": token,
          },
        };
        return axios
          .post(api, item, config)
          .then((response) => {
            if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
          }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
         
        }
      });
      }

//find chef 

static findchef(item) {
  let api = "";
  api = API_PATHS.findchefV2;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static findFreshChefs(item) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .post(API_PATHS.findchefFreshers, item, {
      headers: { "x-access-token": user.data.token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static unlockChefProfile(cookId) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .post(
      API_PATHS.chefProfileUnlock,
      { cookId },
      { headers: { "x-access-token": user.data.token } }
    )
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static findchefV3(item) {
  let api = "";
  api = API_PATHS.findchef;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static chefNotInterested(item) {
  const api = API_PATHS.chefNotInterested;
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api, item, { headers: { "x-access-token": token } })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}


static topchef(item) {
  let api = "";
  api = API_PATHS.findchef;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static employerAplicationSatus(item) {
  let api = "";
  api = API_PATHS.employerapplicationstatus;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .put(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static clientEventSatus(item) {
  let api = "";
  api = API_PATHS.eventrequeststatus;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .put(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static updateHouseJobApplicationStatus(item) {
  const api = API_PATHS.housejobApplicationEdit;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .put(api, item, { headers: { "x-access-token": token } })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

//view shortlisting chefs
static viewshortlistingchefs(item) {
  let api = "";
  api = API_PATHS.viewshortlistchef +`?limit=${item?.limit}&page=${item?.page}&cookType=${item?.cookType}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}


static viewEmployershortlistingchefs(item) {
  let api = "";
  api = API_PATHS.viewshortlistchef +`?limit=${item?.limit}&page=${item?.page}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

/** Employer shortlists v2 (employershortlists collection). */
static viewEmployershortlistingchefsV2(item) {
  const params = new URLSearchParams({
    limit: String(item?.limit ?? 50),
    page: String(item?.page ?? 1),
    cookType: item?.cookType || "chef",
  });
  if (item?.id) params.set("id", item.id);
  if (item?.shortlistId) params.set("shortlistId", item.shortlistId);

  const api = `${API_PATHS.viewshortlistchefV2}?${params.toString()}`;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api, { headers: { "x-access-token": token } })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

//udate weavyid employer
static updateEmployerWeavy(item) {
  let api = "";
  api = API_PATHS.updateemployerWeavyid;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .put(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        localStorage.setItem("weavyId", response?.data?.data?.weavyId)
      }
      return response.data;
    })
}



 //employerjobdetails service
static getEmployerJobDetails(id) {
  let api = "";
  api = API_PATHS.employerjobdetails +"?id="+id;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

static employerReportchefService(item) {
  let api = '';
  api = API_PATHS.reportchefprofile 
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
      .post(api, item, { headers: {"x-access-token" : token}})
      .then((response) => {
          if (response.data) {
              // localStorage.setItem("user", JSON.stringify(response.data));
          }
          return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}



//for shortlisting for chefs (v1 — find-chef list + client cookTypes)
static shortlistchefs(item) {
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  const cookId = item?.cookId || item?.id;
  // Find-chef list: legacy shortlist only (do not call /chef-profile/shortlist)
  const isChefShortlist =
    item?.cookType === "chef" || item?.silentChef === true;
  const body =
    isChefShortlist && cookId ? { id: cookId } : item;

  return axios
    .post(API_PATHS.shortlistcook, body, {
      headers: { "x-access-token": token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

/** Employer → chef shortlist v2 (employershortlists). Body: { id }. */
static shortlistchefsV2(item) {
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  const cookId = item?.cookId || item?.id;
  const body = cookId ? { id: cookId } : item;

  return axios
    .post(API_PATHS.shortlistcookV2, body, {
      headers: { "x-access-token": token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

//store rating for cook 
static storeCookRating(item) {
  let api = "";
  api = API_PATHS.cookrating;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}


// for removing from shortlists (v1 — find-chef list + client cookTypes)
static removeshortlistchefs(item) {
  let api = "";
  api = API_PATHS.removeshortchef;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  const config = {
    headers: {
      "x-access-token": token,
    },
    data:item,
  };
  return axios
    .delete(api,config)
    .then((response) => {
      if (response.data) {
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
}

/** Employer shortlist remove v2. Body: { cookId, cookType: "chef" }. */
static removeshortlistchefsV2(item) {
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .delete(API_PATHS.removeshortchefV2, {
      headers: { "x-access-token": token },
      data: item,
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}



static async getemployerAdvertisement(item) {
  let api = '';
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  api = API_PATHS.getemployerAdvertisements + `?limit=${item.limit}&page=${item.page}&usertype=${item.usertype}`;
  const response = await axios.get(api, { headers: { "x-access-token": token } });
  return response.data; // Extract only the serializable data
}


static employerreachoutactivities(item = {}) {
  const api = API_PATHS.employerreachoutactivitiesV2;
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.token;
  if (!token) {
    console.error('No authentication token found.');
    return;
  }
  const params = {
    limit: Math.min(Number(item.limit) || 25, 50),
  };
  if (item.cursor) {
    params.cursor = item.cursor;
  }
  return axios
    .get(api, {
      params,
      headers: { "x-access-token": token },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.response?.status === 401) {
        logout();
        return;
      }
      console.error('API request failed:', error);
      throw error;
    });
}

    static removeuserDetails() {
        localStorage.removeItem("user");
    }

    static getuserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default EmployerService;